import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { VerifyComponent } from './verify.component';
import { CaptureVideoComponent } from './capture-video/capture-video.component';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { EnrollService } from './enroll.service';
export interface LibConfig {
  apiUrl: string;
}

export const LibConfigService = new InjectionToken<LibConfig>('LibConfig');

@NgModule({
  declarations: [VerifyComponent, CaptureVideoComponent],
  imports: [CommonModule, HttpClientModule],
  exports: [VerifyComponent],
})
export class VerifyModule {
  static forRoot(
    config: LibConfig = {
      apiUrl:
        'https://dev-facade-1ton-http-635t26xtnq-uc.a.run.app/api/v1/one2n/verify/',
    }
  ): ModuleWithProviders<VerifyModule> {
    return {
      ngModule: VerifyModule,
      providers: [
        EnrollService,
        {
          provide: LibConfigService,
          useValue: config,
        },
      ],
    };
  }
}
